import { useContext } from 'react';
import { AuthContext, AuthContextValue } from './authContextCore';

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }

  return value;
}
